export function StatusBadge({ status, isOverdue }) {
  let label = status?.toUpperCase();
  let cls = "bg-[color:var(--pending-bg)] text-[color:var(--pending)]";
  if (status === "paid") cls = "bg-[color:var(--paid-bg)] text-[color:var(--paid)]";
  else if (status === "partial") {
    cls = "bg-[color:var(--pending-bg)] text-[color:var(--pending)]";
    label = isOverdue ? "PARTIAL · OVERDUE" : "PARTIAL";
  } else if (isOverdue) {
    cls = "bg-[color:var(--overdue-bg)] text-[color:var(--overdue)]";
    label = "OVERDUE";
  } else cls = "bg-[color:var(--pending-bg)] text-[color:var(--pending)]";
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider rounded-sm ${cls}`}
    >
      {label}
    </span>
  );
}

export function ReliabilityBadge({ score }) {
  if (score == null)
    return (
      <span className="text-[10px] uppercase tracking-wider text-ink-2">No data</span>
    );
  let cls;
  if (score >= 85) cls = "bg-[color:var(--paid-bg)] text-[color:var(--paid)]";
  else if (score >= 60) cls = "bg-[color:var(--pending-bg)] text-[color:var(--pending)]";
  else cls = "bg-[color:var(--overdue-bg)] text-[color:var(--overdue)]";
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider rounded-sm tabular ${cls}`}
    >
      {score}% on-time
    </span>
  );
}
